import "../assets/styles/pages/home.css";
import myImage from "../assets/images/profile_photo.jpg";
import { scrollToSectionId } from "../utils/scrollToSection";

const YEARS = new Date().getFullYear() - 2020;

function Home() {
    return (
        <section id="home" className="hero section bg-deep" aria-labelledby="hero-title">
            <div className="hero__inner shell">
                <div className="hero__grid">
                    <div className="hero__copy">
                        <p className="hero__eyebrow">Software engineer</p>
                        <h1 id="hero-title" className="hero__title">
                            Anton Korolov
                        </h1>
                        <p className="hero__subtitle">
                            Building reliable web platforms and services — from APIs and data pipelines to polished
                            frontends.
                        </p>
                        <p className="hero__body">
                            Experienced software engineer with an Ing. (Master&apos;s) degree and {YEARS} years of
                            engineering experience. Focused on clear architecture, maintainable code, and steady delivery
                            across the stack.
                        </p>
                        <div className="hero__actions">
                            <button type="button" className="btn-primary" onClick={() => scrollToSectionId("contact")}>
                                Get in touch
                            </button>
                            <button type="button" className="btn-ghost" onClick={() => scrollToSectionId("experience")}>
                                View experience
                            </button>
                        </div>
                    </div>
                    <div className="hero__visual">
                        <div className="hero__frame">
                            <img
                                src={myImage}
                                alt="Portrait of Anton Korolov"
                                width={640}
                                height={800}
                                className="hero__image"
                                decoding="async"
                                {...({ fetchpriority: "high" } as any)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Home;
